export const notificationPlacement = {
  topLeft: 'topLeft',
  topRight: 'topRight',
  bottomLeft: 'bottomLeft',
  bottomRight: 'bottomRight',
};

export const notificationType = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
};

export const notificationDuration = 4;
